export class SearchCondition {
  student_code: string = ""
  name: string = ""
  nendo: string = ""
  subject_code: string = null
  course_code: string = null
  campus_code: string = null
  class_code: string = null
  grade: string = ""
  kumi: string = ""
  student_no: string = ""
  status: string = ""
  page: number = 1
  row_count: number =  100
}

export class StudentSubject {
  id: number
  student_code: string
  student_name: string
  subject_code: string
  subject_name: string
  nendo: number
  course_code: string
  campus_code: string
  class_code: string
  course_name: string
  campus_name: string
  class_name: string
  grade: string
  kumi: string
  student_no: number
  status: number
  is_checked: boolean = false

  constructor(x: any){
    this.id = x.id
    this.student_code = x.student_code
    this.student_name = x.student_name
    this.subject_code = x.subject_code
    this.subject_name = x.subject_name
    this.nendo = x.nendo
    this.course_code = x.course_code
    this.campus_code = x.campus_code
    this.class_code = x.class_code
    this.course_name = x.course_name
    this.campus_name = x.campus_name
    this.class_name = x.class_name
    this.grade = x.grade
    this.kumi = x.kumi
    this.student_no = x.student_no
    this.status = x.status
  }
}